import { deepClone } from '@/utils';

const list = {
  // 在list数据头部插入一个{ 全部数据 }的数据
  // data list数据  name 插入第一个数据显示的name  props 数据别名
  insert: (data, name = '全部', props) => {
    props = Object.assign({ id: 'id', name: 'name' }, props);
    let list = deepClone(data || []);
    let insertData = {};
    insertData[props['id']] = '';
    insertData[props['name']] = name;
    list.unshift(insertData);
    return list;
  },
  // 获取list中条件匹配的值
  getName(list, id, props) {
    props = Object.assign({ id: 'id', name: 'name' }, props);
    for (let i in list) {
      if (list[i][props['id']] === id) return list[i][props['name']];
    }
    return '';
  }
}

export default list;
